module.exports = __webpack_public_path__ + "img/metropolitana.138525c5.svg";